import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Slider, Select, InputNumber } from 'antd';

const { Option } = Select;


const DivisionProblemSettings = (props) => {
    const [settings, setSettings] = useState({ numberOfProblems: props.numberOfProblems, divisor_start: props.divisor_start, divisor_end: props.divisor_end,  dividend_start: props.dividend_start, dividend_end: props.dividend_end })

    const onSliderValueChange = (key, value) => {
        setSettings({ ...settings, [key]: value })
    }

    useEffect(() => {
        props.onChange(settings)
    }, [settings])

    return <>
            <div class="display-settings-row">
                <Row>
                    <Col>
                        <span class="label">Number of Problems</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Slider
                            min={10}
                            max={50}
                            onChange={(value) => onSliderValueChange('numberOfProblems', value)}
                            value={typeof settings.numberOfProblems === 'number' ? settings.numberOfProblems : 0}
                        />
                    </Col>
                </Row>
            </div>
            <div class="display-settings-row">
                <Row class="label">
                    <Col>
                        <span class="label">Divisor (start - end)</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputNumber min={1} max={1000} defaultValue={settings.divisor_start} onChange={(value) => onSliderValueChange('divisor_start', value)} /> -
                    </Col> 
                    <Col>
                        <InputNumber min={1} max={100000} defaultValue={settings.divisor_end} onChange={(value) => onSliderValueChange('divisor_end', value)} />
                    </Col>
                </Row>
            </div>
            <div class="display-settings-row">
                <Row class="label">
                    <Col>
                        <span class="label">Dividend (start - end)</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputNumber min={1} max={1000} defaultValue={settings.dividend_start} onChange={(value) => onSliderValueChange('dividend_start', value)} /> -
                    </Col> 
                    <Col>
                        <InputNumber min={1} max={100000} defaultValue={settings.dividend_end} onChange={(value) => onSliderValueChange('dividend_end', value)} />
                    </Col>
                </Row>
            </div>
    </>;
}

export default DivisionProblemSettings;

/*
font-family: 'Cutive Mono', monospace;
font-family: 'Dancing Script', cursive;
font-family: 'DotGothic16', sans-serif;
font-family: 'Indie Flower', cursive;
font-family: 'Poppins', sans-serif;
font-family: 'Roboto', sans-serif;
font-family: 'Sacramento', cursive;
font-family: 'Shadows Into Light', cursive;
font-family: 'Teko', sans-serif;
*/